module.exports = __webpack_public_path__ + "img/1483365688.8e08e4d2.jpg";